import React, { useState } from "react";
import Achievements from "./UserList/Achievements";
import AllEvents from "./UserList/AllEvents";
import CheckingDetails from "./UserList/CheckingDetails";
import Merchandise from "./UserList/Merchandise";
import ArtLog from "./UserList/ArtLog";
import ArtProjects from "./UserList/ArtProjects";
import UserDetails from "./UserList/UserDetails";
import UserAttendList from "./UserList/UserAttendList";
import WalletFunds from "./UserList/walletFunds";

import {
  apiCallGetWalletFunds,
  apiCallGetArtrunerWallet
} from '../../../Core/Apicall'
import UserSubscriptionProfile from "./UserList/UserSubscriptionProfile";

const UserTab = ({ userId, userDetails, isFullProfile }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = isFullProfile ? [
    "Profile Details",
    "Achievements",
    "All Events",
    "Attend Events",
    "Check-In Events",
    "Merchandise",
    "ArtLog",
    "Art Projects",
    "User Wallet",
    "ArtRunner Wallet",
    "Subscriptions",

  ] : ["Profile Details"];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <div className="user-profile-custom-container margin-top-20">
        {tabs.map((tab, index) => (
          <div
            key={index.toString()}
            style={{
              padding: "10px",
              fontWeight: "400",
              color: index != activeTab ? "rgba(255, 255, 255, 0.5)" : " #fff",
              borderBottom: index != activeTab ? "" : "1px solid #fff",
              cursor: "pointer",
            }}
            className="fontSize18"
            onClick={() => handleTabClick(index)}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="margin-top-20">
        {activeTab === 0 && (
          <div className="grid grid-cols-2 gap-7">
            <UserDetails userDetails={userDetails} />
          </div>
        )}

        {activeTab === 1 && (
          <div className="grid grid-cols-2 gap-7">
            <Achievements userId={userId} />
          </div>
        )}

        {activeTab === 2 && (
          <div>
            <AllEvents userId={userId} />
          </div>
        )}

        {activeTab === 3 && (
          <div className="text-white mt-8 font-bold">
            <UserAttendList userId={userId} />
          </div>
        )}

        {activeTab === 4 && (
          <div className="text-white mt-8 font-bold">
            <CheckingDetails userId={userId} />
          </div>
        )}


        {activeTab === 5 && (
          <div className="text-white mt-8 font-bold">
            <Merchandise userId={userId} />
          </div>
        )}

        {activeTab === 6 && (
          <div className="text-white mt-8 font-bold">
            <ArtLog userId={userId} />
          </div>
        )}

        {activeTab === 7 && (
          <div className="text-white mt-8 font-bold">
            <ArtProjects userId={userId} />
          </div>
        )}

        {activeTab === 8 && (
          <div className="text-white mt-8 font-bold">
            <WalletFunds
              userId={userId}
              title="User Wallet"
              apiFunction={apiCallGetWalletFunds}
            />
          </div>
        )}

        {activeTab === 9 && (
          <div className="text-white mt-8 font-bold">
            <WalletFunds
              userId={userId}
              title="ArtRunner Wallet"
              apiFunction={apiCallGetArtrunerWallet}
            />
          </div>
        )}
        {activeTab === 10 && (
          <div className="text-white mt-8 font-bold">
            <UserSubscriptionProfile
              userId={userId}
              userType={"Artist"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTab;
